import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoTotally = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13.57 2h-4.1l4.1 4.13V2ZM8 11.14h1.37l.02 5.75c0 4.49 4.13 5.11 5 5.11.712.008 1.422-.059 2.12-.2v-3.73a9.456 9.456 0 0 1-1.07.11c-1.26 0-1.81-.51-1.81-1.9v-5.14h2.63V7.41H8v3.73Z"
    />
  </svg>
);
export default SvgLogoTotally;
